<template>
  <div class="row m-0" :key="num">
    <div class="col-12 ">
      <transition name="fade">
        <div class="row m-0 align-items-center justify-content-center loadingItem" v-if="isShopLoading">
          <grid-loader :loading="isShopLoading" size="50px"></grid-loader>
        </div>
      </transition>
      <div class="row justify-content-center" v-if="!isShopLoading">
        <div class="col-lg-6 pl-lg-0 pr-lg-1">
          <div class="row m-0 ">
            <card title="Shop Details">
              <!--LOGO-->
              <div class="row mx-0 mb-3">
                <div class="col-12 bold mb-2">
                  Logo
                </div>
                <div class="col-6 col-sm-4 col-md-4 col-lg-5 col-xl-6 mb-3 pointer" @click="editLogo = true">
                  <img :src="details.logo" alt="" class="img-fluid" v-if="details.logo">
                  <img src="@/assets/images/placeholder-square.png" alt="" class="img-fluid" v-else>
                  <div class="edit_icon">
                    <span class="material-icons" @click="$emit('editimg')">
                      edit
                    </span>
                  </div>
                </div>
              </div>
              <!--END LOGO-->
              <!--IMAGE-->
              <div class="row mx-0 mb-3">
                <div class="col-12 bold mb-2">
                  Header background
                </div>
                <div class="col-7 col-sm-6 col-md-5 col-lg-6 col-xl-6 mb-3 pointer" @click="editHeaderImg = true">
                  <img :src="details.headerImg" alt="" class="img-fluid" v-if="details.headerImg">
                  <img src="@/assets/images/placeholder-square.png" alt="" class="img-fluid" v-else>
                  <div class="edit_icon">
                    <span class="material-icons" @click="$emit('editimg')">
                      edit
                    </span>
                  </div>
                </div>
              </div>
              <!--END IMAGE-->
              <!--NAME-->
              <text-input title="Shop Name" v-model="details.name"/>
              <!--END NAME-->
              <!--DESCRIPTION-->
              <text-input title="Description" v-model="details.description" :multiline="true"/>
              <text-input title="Display Address" v-model="details.address"/>
              <div class="row mx-0 mb-3">
                <div class="col-12 bold mb-2">
                  Category
                </div>
                <div class="col-12">
                  <select class="custom-select form-control" v-model="details.category">
                    <option disabled>--Select--</option>
                    <option value="Food - Ready to Eat">Food - Ready to Eat</option>
                    <option value="Food">Food</option>
                    <option value="Products">Products</option>
                    <option value="Professional Services">Professional Services</option>
                    <option value="Health">Health</option>
                    <option value="Entertainment">Entertainment</option>
                  </select>
                </div>
              </div>
              <!--END DESCRIPTION-->
              <!--WHATSAPP-->
              <div class="row mx-0 mb-3">
                <div class="col-12 mb-2 bold">
                  WhatsApp Support Number
                </div>
                <div class="col-12">
                  <vue-tel-input v-model="number" v-bind="bindProps" @input="acceptNumber"></vue-tel-input>
                  <!-- <input type="text" v-model="details.whatsapp"  class="form-control w-100"> -->
                </div>
              </div>
              <!-- <input
                type="tel"
                name="whatsapp"
                id="whatsapp"
                class="form-control"
                placeholder="Mobile Number"
                v-model="mobile"
                required
              />
              <text-input title="WhatsApp Support Number" v-model="details.whatsapp"/> -->
              <!--END WHATSAPP-->
            </card>
            <company-details :companyDetails.sync="adminDetails.companyDetails"/>
            <notifications :adminDetails.sync="adminDetails.notifications"/>
          </div>
        </div>
        <div class="col-lg-6 pr-lg-0">
          <div class="row m-0">
            <shipping v-model="details.shipping"/>
            <payment v-model="details.payment" :adminDetails.sync="adminDetails"/>
          </div>
        </div>
        <div class="col-12 py-4">
          <div class="row justify-content-end">
            <div class="col-12 col-lg-6 pr-lg-0">
              <div class="row justify-content-end">
                <div class="col-6">
                  <button type="button" class="btn btn-primary w-100" @click="updateDetails">Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0" v-if="editLogo">
        <logo-gallery :name="details.name" :logo="details.logo" @close="editLogo = false" @save="updateLogoTemp" ></logo-gallery>
      </div>
      <div class="row m-0" v-if="editHeaderImg">
        <logo-gallery :name="details.headerImg" :logo="details.headerImg" @close="editHeaderImg = false" @save="updateHeaderImgTemp"></logo-gallery>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loadingMixin from '@/mixins/loading'
import { VueTelInput } from 'vue-tel-input'

export default {
  components: {
    GridLoader: () => import('vue-spinner/src/MoonLoader.vue'),
    'logo-gallery': () => import('@/components/shop/LogoGallery.vue'),
    Card: () => import('@/components/common/Card.vue'),
    CompanyDetails: () => import('@/components/shop/CompanyDetails.vue'),
    Notifications: () => import('@/components/shop/Notifications.vue'),
    Shipping: () => import('@/components/shop/Shipping.vue'),
    Payment: () => import('@/components/shop/Payment.vue'),
    TextInput: () => import('@/components/common/TextInput.vue'),
    VueTelInput
  },
  data () {
    return {
      editLogo: false,
      editHeaderImg: false,
      loading: false,
      num: 0,
      number: '',
      details: {
        domain: '',
        category: '',
        name: '',
        description: '',
        logo: '',
        headerImg: '',
        whatsapp: '',
        shipping: {}
      },
      adminDetails: {
        companyDetails: {},
        notifications: {},
        orderNumber: 0,
        yoco: {
          secretKey: ''
        }
      },
      bindProps: {
        mode: 'international',
        defaultCountry: 'ZA',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        preferredCountries: ['AU', 'US', 'GB', 'IT', 'ZA'],
        placeholder: 'WhatsApp Number',
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        autocomplete: 'on',
        name: 'telephone',
        wrapperClasses: '',
        inputClasses: '',
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['shopDetails', 'isShopLoading', 'shopAdminDetails'])
  },
  watch: {
    shopDetails () {
      this.details = Object.assign({}, this.details, this.shopDetails)
    },
    shopAdminDetails () {
      this.adminDetails = Object.assign({}, this.adminDetails, this.shopAdminDetails)
    }
  },
  mounted () {
    console.log('mounted')
    this.details = Object.assign({}, this.details, this.shopDetails)
    this.adminDetails = Object.assign({}, this.adminDetails, this.shopAdminDetails)
    this.number = this.details.whatsapp
    this.num = Math.random() // not sure why, but if you don't use this key to force rerender, when you visit the page again, it is empty
  },
  methods: {
    ...mapActions(['addMessage', 'setShopLoading', 'updateShopDetails', 'updateShopAdminDetails', 'getShopDetails', 'getShopAdminDetails']),
    updateDetails () {
      this.showLoading()
      this.setShopLoading(true)
      this.updateShopAdminDetails(this.adminDetails).then(() => {
        this.updateShopDetails(this.details).then(() => {
          this.hideLoading()
        })
      })
    },
    acceptNumber () {
      var x = this.number.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.details.whatsapp = !x[2] ? x[1] : x[1] + x[2] + x[3] + x[4]
    },
    updateLogoTemp (newLogo) {
      this.editLogo = false
      this.details.logo = newLogo
    },
    updateHeaderImgTemp (newHeaderImg) {
      this.editHeaderImg = false
      this.details.headerImg = newHeaderImg
    }
  },
  mixins: [loadingMixin]
}
</script>

<style scoped>
.edit_icon {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  bottom: -0.3rem;
  right: 0;
  z-index: 2;
  color: var(--dark-color);
}
.dark-mode .edit_icon {
  color: var(--light-color);
}
  .btn_add {
    color: white;
    cursor: pointer;
    border: 1px solid white;
    position: absolute;
    bottom: 0;
    left: 100%;
    z-index: 99;
  }
</style>
